import Vue from 'vue'
import AppComponent from './AppComponent.vue'
import router from './router/index'
import store from './store/store'

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(AppComponent)
}).$mount('#app');
